'use strict';
/* eslint no-sync: 0 */

import angular from 'angular';

export class NavbarComponent {
  isCollapsed = true;

  constructor(Auth, $state, $location, ViewSelection, CommunityService, SettingsService, RecentVisits, PinnedItems, $scope) {
    'ngInject';

    this.ViewSelection = ViewSelection;

    this.isLoggedIn = Auth.isLoggedInSync;
    this.isAdmin = Auth.isAdminSync;
    this.isSuperAdmin = Auth.isSuperAdminSync;
    this.getCurrentUser = Auth.getCurrentUserSync;
    this.$state = $state;
    this.$location = $location;
    this.RecentVisits = RecentVisits;
    this.PinnedItems = PinnedItems;
    this.CommunityService = CommunityService;
    this.Auth = Auth;

    this.communities = [];
    this.communityEnum = [];

    this.busy = true;

    this.periodEnum = ["1/1/17 - 12/31/18"];

    this.searchterm = null;
    this.searchSubmitted = false;

    SettingsService.getByName({name: 'config.app'}, settings => {

      this.menu = (settings.data.customMenu) ? settings.data.customMenu : [
        {
          title: 'Calendar',
          url: '/calendar/list'
        },
        {
          title: 'Portfolio',
          subMenu: [{
            title: 'Communities',
            url: '/community/list'
          },{
            title: 'Properties',
            url: '/property/list'
          },{
            title: 'Contacts',
            url: '/contact/list'
          },{
            title: 'Vendors',
            url: '/vendor/list'
          },{
            title: 'Projects (beta)',
            url: '/project/list'
          },{
            title: 'Web Access',
            url: "/webaccess/list"
          }]
        },
        {
          title: 'Service Requests',
          url: '/servicerequest/ticket/list'
        },{
          title: 'Work Orders',
          url: '/workorder/ticket/list'
        }, {
          title: 'Violations',
          url: '/violation/ticket/list'
        }, {
          title: 'Reports',
          url: '/reports'
        },{
          title: 'Communication',
          subMenu: [
            {
              title: 'Mails',
              url: '/mail/draft/list'
            },
            {
              title: 'Text Messages',
              url: '/text/draft/list'
            },
            {
              title: 'E-Forms',
              url: '/e-form/list'
            }
          ]
        }, {
          title: 'Admin',
          adminOnly: true,
          subMenu: [
            {
              title: 'Management Company',
              url: '/admin/client/edit'
            },
            {
              title: 'User Management',
              url: '/admin/users'
            },
            {
              separator: true
            },
            {
              title: 'Work Order Codes',
              url: '/workorder/code/list'
            },{
              title: 'Violation Codes',
              url: '/violation/code/list'
            },{
              title: 'Letter Templates',
              url: '/template/list'
            }
          ]
        }];

      this.publicMenu = [];

      SettingsService.getByName({name: 'client'}, clientData => {
        this.communityEnum = [{
          name: clientData.data.name,
          group: "Management",
          value: ""
        }];

        if (clientData.data.eVotingEnabled) {
          this.menu[1].subMenu.push({
            title: "Voter Groups",
            url: "/voter-group/list"
          });
        }

        if (clientData.data.customPortfolio) {
          this.menu[1].subMenu.push({separator: true});

          clientData.data.customPortfolio.forEach(custom => {
            this.menu[1].subMenu.push({
              title: custom.title,
              url: custom.url
            });
          })
        }

        if (clientData.data.quickbooksEnabled) {
          this.quickbooksEnabled = true;
          this.menu.splice(5, 0, {
            title: 'QB Balances',
            url: '/admin/list/quickbooks-overview'
          });
        }

        if (clientData.data.paymentsEnabled) {
          this.paymentsEnabled = true;
          this.menu.splice(5, 0, {
            title: 'Payments',
            url: '/payments'
          });
        }

        if (clientData.data.customViews) {
          let customViewEntries = [];
          clientData.data.customViews.forEach(custom => {
            customViewEntries.push({
              title: custom.title,
              url: custom.url
            });
          });
          this.menu.splice(2, 0, {
            title: 'Views',
            subMenu: customViewEntries
          });
        }

        this.busy = false;
      });

    });
  }

  $doCheck() {
    this.isWebAccessMatter = this.$state.current.name == 'webaccess-reset-password';

    if (!this.communities.length && !this.busy && this.Auth.isLoggedInSync()) {
      this.busy = true;
      this.CommunityService.query(communities => {
        this.communities = communities;
        communities.forEach(community => {
          this.communityEnum.push({
            name: community.name,
            value: community.code,
            group: "Associations"
          })
        });

        this.busy = false;
        this.communityChanged();
      });
    }
  }

  isActive(routePart) {
    return this.$location.path().indexOf(routePart) !== -1;
  };

  communityChanged() {
    let cmty = this.communityEnum.find(cmty => cmty.value == this.ViewSelection.selectedCommunityCode);
    this.ViewSelection.selectedCommunity = cmty;
  }

  search(form) {
    this.searchSubmitted = true;

    if(form.$valid) {
      this.searchSubmitted = false;
      this.$state.go('search-result',{searchterm: this.searchterm});
    }
  }
}

export default angular.module('directives.navbar', [])
  .component('navbar', {
    template: require('./navbar.html'),
    controller: NavbarComponent
  })
  .name;



// WEBPACK FOOTER //
// ./client/components/navbar/navbar.component.js